import { useMemo } from 'react';
import { addMediaImportClick } from '@wix/bi-logger-media-data/v2';
import { bi } from '../../../services/loggers/bi';

export const useTrackAddMediaImportClickAnalytics = () =>
  useMemo(
    () => ({
      trackAddMediaImportClick: (params) => bi.logger().report(addMediaImportClick(params)),
    }),
    [],
  );
